var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4225 5.38947C6.03874 5.21053 5.87564 4.68947 6.1059 4.31053C6.57121 3.55263 7.34832 3 8.37488 3C9.50217 3 10.2745 3.56316 10.6678 4.26842C11.0036 4.87368 11.2003 6.00526 10.6822 6.84737C10.1066 7.77895 9.55494 8.06316 9.25752 8.66316C9.18557 8.80526 9.1424 8.92105 9.11361 9.1579C9.07044 9.54211 8.78262 9.84211 8.42764 9.84211C8.01031 9.84211 7.66972 9.44737 7.71769 8.98947C7.74647 8.72105 7.80403 8.44211 7.93835 8.17895C8.30772 7.44737 9.01767 7.01579 9.43022 6.36842C9.86674 5.68947 9.6221 4.42105 8.38447 4.42105C7.82322 4.42105 7.45865 4.74211 7.23319 5.12632C7.0653 5.42632 6.71512 5.52105 6.4225 5.38947ZM9.33907 11.9474C9.33907 12.5263 8.90734 13 8.37967 13C7.852 13 7.42028 12.5263 7.42028 11.9474C7.42028 11.3684 7.852 10.8947 8.37967 10.8947C8.90734 10.8947 9.33907 11.3684 9.33907 11.9474Z",
    fill: "#5B5B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryInfo);
export default __webpack_public_path__ + "static/media/historyInfo.92c27e921599c7685db6e8f284e645d6.svg";
export { ForwardRef as ReactComponent };